/* ZANVE theme — drawers, cart (AJAX Cart API), accordions, carousels, reveal */
(function(){
  'use strict';

  var cfgEl = document.getElementById('zv-config');
  var CFG = {};
  try { CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch(e) { CFG = {}; }

  /* ---------------- drawers ---------------- */
  var scrim = document.querySelector('[data-zv-scrim]');
  var navDrawer = document.querySelector('[data-zv-nav-drawer]');
  var cartDrawer = document.querySelector('[data-zv-cart-drawer]');

  function setVh(){
    var h = window.innerHeight || document.documentElement.clientHeight;
    document.documentElement.style.setProperty('--zv-vh', h + 'px');
  }
  setVh();
  window.addEventListener('resize', setVh, { passive: true });

  function openDrawer(el){
    if(!el) return;
    el.classList.add('zv-open');
    if(scrim) scrim.classList.add('zv-open');
    document.body.style.overflow = 'hidden';
  }
  function closeAllDrawers(){
    if(navDrawer) navDrawer.classList.remove('zv-open');
    if(cartDrawer) cartDrawer.classList.remove('zv-open');
    if(scrim) scrim.classList.remove('zv-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e){
    var openNav = e.target.closest('[data-zv-open-nav]');
    var openCart = e.target.closest('[data-zv-open-cart]');
    var closeNav = e.target.closest('[data-zv-close-nav]');
    var closeCart = e.target.closest('[data-zv-close-cart]');
    var scrimHit = e.target.closest('[data-zv-scrim]');

    if(openNav){ e.preventDefault(); openDrawer(navDrawer); }
    if(openCart){ e.preventDefault(); openDrawer(cartDrawer); }
    if(closeNav || closeCart || scrimHit){ e.preventDefault(); closeAllDrawers(); }
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeAllDrawers();
  });

  /* ---------------- accordions (FAQ + expandables) ---------------- */
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-zv-toggle]');
    if(!trigger) return;
    var item = trigger.closest('[data-zv-accordion-item]');
    if(item) item.classList.toggle('is-open');
  });

  /* ---------------- carousels ---------------- */
  document.addEventListener('click', function(e){
    var arrow = e.target.closest('[data-zv-scroll]');
    if(!arrow) return;
    var wrap = arrow.closest('[data-zv-carousel]');
    if(!wrap) return;
    var track = wrap.querySelector('[data-zv-track]');
    if(!track) return;
    var dir = arrow.getAttribute('data-zv-scroll') === 'right' ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
  });

  /* ---------------- scroll reveal ---------------- */
  (function(){
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = document.querySelectorAll('[data-reveal],[data-reveal-scale],[data-reveal-slow]');
    if(!els.length) return;
    if(reduce || !('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('zv-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('zv-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function(el){ io.observe(el); });
  })();

  /* ---------------- product option / variant selection ---------------- */
  document.addEventListener('click', function(e){
    var opt = e.target.closest('[data-zv-option]');
    if(!opt) return;
    var form = opt.closest('[data-zv-product-form]');
    if(!form) return;
    var group = opt.getAttribute('data-zv-option-name');
    form.querySelectorAll('[data-zv-option-name="' + CSS.escape(group) + '"]').forEach(function(b){
      b.classList.remove('is-active');
    });
    opt.classList.add('is-active');
    updateSelectedVariant(form);
  });

  function updateSelectedVariant(form){
    var selected = {};
    form.querySelectorAll('.is-active[data-zv-option]').forEach(function(b){
      selected[b.getAttribute('data-zv-option-name')] = b.getAttribute('data-zv-option-value');
    });
    var variants = JSON.parse(form.getAttribute('data-zv-variants') || '[]');
    var optionNames = JSON.parse(form.getAttribute('data-zv-option-names') || '[]');
    var match = variants.find(function(v){
      return v.options.every(function(val, i){
        var name = optionNames[i];
        return !selected[name] || selected[name] === val;
      });
    });
    if(!match) return;
    form.querySelector('[name="id"]').value = match.id;
    var priceEl = form.querySelector('[data-zv-price]');
    var subEl = form.querySelector('[data-zv-price-sub]');
    if(priceEl) priceEl.textContent = formatMoney(match.price);
    if(subEl) subEl.textContent = match.compare_at_price && match.compare_at_price > match.price
      ? 'save ' + formatMoney(match.compare_at_price - match.price) : (subEl.getAttribute('data-zv-default') || '');
    var addBtn = form.querySelector('[data-zv-add]');
    if(addBtn) addBtn.disabled = !match.available;
    var colorLabelEl = form.querySelector('[data-zv-color-name]');
    if(colorLabelEl && selected.Color) colorLabelEl.textContent = selected.Color;
    if(match.featured_image && match.featured_image.id){
      scrollGalleryToImageId(match.featured_image.id, form.closest('.zv-product__layout'));
    }
    var offerLink = form.querySelector('[data-zv-offer-link]');
    if(offerLink){
      offerLink.href = offerLink.href.split('?')[0] + '?variant=' + match.id;
    }
    updateQtyUI(form, lastCart);
  }

  /* ---------------- gallery ---------------- */
  function scrollGalleryToImageId(imageId, scope, behavior){
    if(!imageId) return;
    var track = (scope || document).querySelector('[data-zv-gallery-track]');
    if(!track) return;
    var slide = track.querySelector('[data-zv-image-id="' + CSS.escape(String(imageId)) + '"]');
    if(slide) track.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'smooth' });
  }

  document.addEventListener('click', function(e){
    var thumb = e.target.closest('[data-zv-gallery-thumb]');
    if(!thumb) return;
    var scope = thumb.closest('[data-zv-gallery]');
    scrollGalleryToImageId(thumb.getAttribute('data-zv-gallery-image-id'), scope);
  });

  document.querySelectorAll('[data-zv-gallery-track]').forEach(function(track){
    var initialId = track.getAttribute('data-zv-initial-image-id');
    if(initialId) scrollGalleryToImageId(initialId, track.closest('[data-zv-gallery]'), 'auto');
  });

  document.querySelectorAll('[data-zv-gallery]').forEach(function(gallery){
    var track = gallery.querySelector('[data-zv-gallery-track]');
    var thumbs = gallery.querySelectorAll('[data-zv-gallery-thumb]');
    if(!track || !thumbs.length) return;
    function updateActiveThumb(){
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var closest = null, closestDist = Infinity;
      track.querySelectorAll('[data-zv-gallery-slide]').forEach(function(slide){
        var r = slide.getBoundingClientRect();
        var dist = Math.abs((r.left + r.width / 2) - center);
        if(dist < closestDist){ closestDist = dist; closest = slide; }
      });
      if(!closest) return;
      var id = closest.getAttribute('data-zv-image-id');
      thumbs.forEach(function(t){
        t.classList.toggle('is-active', id != null && t.getAttribute('data-zv-gallery-image-id') === id);
      });
    }
    track.addEventListener('scroll', function(){
      window.requestAnimationFrame(updateActiveThumb);
    }, { passive: true });
    updateActiveThumb();
  });

  /* ---------------- quantity stepper (buy box) ---------------- */
  var lastCart = null;

  function updateQtyUI(form, cart){
    var qtyRow = form.querySelector('[data-zv-qty-row]');
    var addBtn = form.querySelector('[data-zv-add]');
    if(!qtyRow || !addBtn || !cart) return;
    var variantId = form.querySelector('[name="id"]').value;
    var line = cart.items.find(function(i){ return String(i.variant_id) === String(variantId); });
    var qty = line ? line.quantity : 0;
    if(qty > 0){
      addBtn.style.display = 'none';
      qtyRow.style.display = 'flex';
      var valueEl = qtyRow.querySelector('[data-zv-qty-value]');
      if(valueEl) valueEl.textContent = qty;
    } else {
      addBtn.style.display = '';
      qtyRow.style.display = 'none';
    }
  }

  document.addEventListener('click', function(e){
    var stepBtn = e.target.closest('[data-zv-qty-plus],[data-zv-qty-minus]');
    if(!stepBtn) return;
    var form = stepBtn.closest('[data-zv-product-form]');
    if(!form) return;
    var variantId = form.querySelector('[name="id"]').value;
    var valueEl = form.querySelector('[data-zv-qty-value]');
    var current = valueEl ? parseInt(valueEl.textContent, 10) || 0 : 0;
    var delta = stepBtn.hasAttribute('data-zv-qty-plus') ? 1 : -1;
    var next = Math.max(0, current + delta);
    postCart('/cart/change.js', { id: variantId, quantity: next })
      .then(refreshCart)
      .catch(function(err){ showCartError(err.message); });
  });

  function formatMoney(cents){
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------------- cart (AJAX Cart API) ---------------- */
  function fetchCart(){
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); });
  }

  function postCart(url, body){
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r){
      return r.json().then(function(data){
        if(!r.ok){
          throw new Error((data && (data.description || data.message)) || 'Something went wrong. Please try again.');
        }
        return data;
      });
    });
  }

  function showCartError(message){
    var toast = document.querySelector('[data-zv-cart-toast]');
    if(!toast){
      toast = document.createElement('div');
      toast.setAttribute('data-zv-cart-toast', '');
      toast.className = 'zv-cart-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._zvHideTimer);
    toast._zvHideTimer = setTimeout(function(){ toast.classList.remove('is-visible'); }, 4000);
  }

  function renderCart(cart){
    lastCart = cart;
    document.querySelectorAll('[data-zv-product-form]').forEach(function(form){
      updateQtyUI(form, cart);
    });

    var root = document.querySelector('[data-zv-cart-drawer]');
    if(!root) return;

    var count = cart.item_count;
    document.querySelectorAll('[data-zv-cart-count]').forEach(function(el){ el.textContent = count; });

    var hasBrush = CFG.brushVariantIds && cart.items.some(function(i){ return CFG.brushVariantIds.indexOf(i.variant_id) !== -1; });
    var hasMassager = CFG.massagerVariantIds && cart.items.some(function(i){ return CFG.massagerVariantIds.indexOf(i.variant_id) !== -1; });
    var empty = cart.items.length === 0;

    var itemsList = root.querySelector('[data-zv-cart-items]');
    var itemsOuterWrap = root.querySelector('[data-zv-cart-items-wrap]');
    var emptyWrap = root.querySelector('[data-zv-cart-empty]');
    var footWrap = root.querySelector('[data-zv-cart-foot]');
    var crossWrap = root.querySelector('[data-zv-cross-sell]');
    var bundleWrap = root.querySelector('[data-zv-bundle-banner]');

    if(emptyWrap) emptyWrap.style.display = empty ? '' : 'none';
    if(itemsOuterWrap) itemsOuterWrap.style.display = empty ? 'none' : '';
    if(footWrap) footWrap.style.display = empty ? 'none' : '';

    if(itemsList && !empty){
      itemsList.innerHTML = cart.items.map(function(item){
        return '' +
          '<div class="zv-line-item">' +
            '<a class="zv-line-item__media" href="' + item.url + '"><img src="' + (item.image ? item.image.replace('{width}','120') : '') + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy"></a>' +
            '<div class="zv-line-item__body">' +
              '<div class="zv-line-item__title">' + escapeHtml(item.product_title) + '</div>' +
              '<div class="zv-line-item__meta">' + escapeHtml(item.variant_title || '') + (item.quantity > 1 ? ' · Qty ' + item.quantity : '') + '</div>' +
            '</div>' +
            '<div class="zv-line-item__aside">' +
              '<div class="zv-line-item__price">' + formatMoney(item.final_line_price) + '</div>' +
              '<button type="button" class="zv-line-item__remove" data-zv-remove="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>';
      }).join('');
    }

    var discountApps = cart.cart_level_discount_applications || [];
    if(bundleWrap){
      if(hasBrush && hasMassager && discountApps.length){
        bundleWrap.style.display = '';
        bundleWrap.textContent = 'Bundle applied — you saved ' + formatMoney(cart.total_discount) + '.';
      } else {
        bundleWrap.style.display = 'none';
      }
    }

    if(crossWrap){
      var showCross = !empty && (hasBrush !== hasMassager) && CFG.brush && CFG.massager;
      if(showCross){
        var offerProduct = hasBrush ? CFG.massager : CFG.brush;
        crossWrap.style.display = '';
        var media = crossWrap.querySelector('[data-zv-cross-media]');
        var headEl = crossWrap.querySelector('[data-zv-cross-head]');
        var saveEl = crossWrap.querySelector('[data-zv-cross-save]');
        var offerEl = crossWrap.querySelector('[data-zv-cross-offer]');
        var link = crossWrap.querySelector('[data-zv-cross-link]');
        var addBtn = crossWrap.querySelector('[data-zv-quick-add]');
        if(media) media.innerHTML = offerProduct.image ? '<img src="' + offerProduct.image + '" alt="">' : '';
        if(headEl) headEl.textContent = 'Add the ' + offerProduct.title;
        if(saveEl) saveEl.textContent = CFG.bundleSavingsLabel || 'Save $20';
        if(offerEl){
          var offerCopy = hasBrush
            ? 'Save $20 and give yourself the relief you deserve.'
            : 'Save $20 and complete your clean routine.';
          offerEl.textContent = offerProduct.priceLabel + ' — ' + offerCopy;
        }
        if(link) link.href = offerProduct.url;
        if(addBtn) addBtn.setAttribute('data-zv-quick-add', offerProduct.variantId);
      } else {
        crossWrap.style.display = 'none';
      }
    }

    var subtotalEl = root.querySelector('[data-zv-subtotal]');
    var totalEl = root.querySelector('[data-zv-total]');
    var discountRow = root.querySelector('[data-zv-discount-row]');
    if(subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
    if(totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if(discountRow){
      if(hasBrush && hasMassager && cart.total_discount > 0){
        discountRow.style.display = '';
        discountRow.querySelector('[data-zv-discount-amount]').textContent = '−' + formatMoney(cart.total_discount);
      } else {
        discountRow.style.display = 'none';
      }
    }
  }

  function refreshCart(){
    return fetchCart().then(renderCart);
  }

  document.addEventListener('submit', function(e){
    var form = e.target.closest('[data-zv-product-form]');
    if(!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var addBtn = form.querySelector('[data-zv-add]');
    var originalText = addBtn ? addBtn.textContent : '';
    if(addBtn){ addBtn.disabled = true; addBtn.textContent = 'Adding…'; }
    postCart('/cart/add.js', {
      id: fd.get('id'),
      quantity: 1
    }).then(function(){
      return refreshCart();
    }).then(function(){
      openDrawer(cartDrawer);
    }).catch(function(err){
      showCartError(err.message);
    }).finally(function(){
      if(addBtn){ addBtn.disabled = false; addBtn.textContent = originalText; }
    });
  });

  document.addEventListener('click', function(e){
    var buyNow = e.target.closest('[data-zv-buy-now]');
    if(buyNow){
      var form = buyNow.closest('[data-zv-product-form]');
      if(!form) return;
      var id = form.querySelector('[name="id"]').value;
      e.preventDefault();
      buyNow.disabled = true;
      postCart('/cart/add.js', { id: id, quantity: 1 }).then(function(){
        window.location.href = '/checkout';
      }).catch(function(err){
        buyNow.disabled = false;
        showCartError(err.message);
      });
      return;
    }
    var removeBtn = e.target.closest('[data-zv-remove]');
    if(removeBtn){
      e.preventDefault();
      postCart('/cart/change.js', { id: removeBtn.getAttribute('data-zv-remove'), quantity: 0 })
        .then(refreshCart)
        .catch(function(err){ showCartError(err.message); });
      return;
    }
    var quickAdd = e.target.closest('[data-zv-quick-add]');
    if(quickAdd){
      e.preventDefault();
      postCart('/cart/add.js', { id: quickAdd.getAttribute('data-zv-quick-add'), quantity: 1 }).then(refreshCart).then(function(){
        openDrawer(cartDrawer);
      }).catch(function(err){ showCartError(err.message); });
      return;
    }
  });

  function escapeHtml(str){
    return String(str || '').replace(/[&<>"']/g, function(c){
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  /* initial cart render on load so counts/cross-sell reflect real cart state */
  document.addEventListener('DOMContentLoaded', function(){ refreshCart(); });
})();
